import { BillingDetailsTab } from './BillingDetailsTab/BillingDetailsTab';
import { EntityInfoTab } from './EntityInfoTab/EntityInfoTab';

export const tabs = [
	{ title: 'Public Information', component: (prop?: any) => <EntityInfoTab {...prop} /> },
	{ title: 'Billing Details', component: (prop?: any) => <BillingDetailsTab {...prop} /> },
];
